// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__uYZB1","pendingPaymentIcon":"CalendarEvent_pendingPaymentIcon__W2HOl","gfeWrapper":"CalendarEvent_gfeWrapper__2AZSa"};